import React from "react";
import JobPhotosTab from "../shared/tabs/JobPhotosTab";

const TabContent = ({ activeTab, formData, onChange }) => {
  const renderTab = () => {
    const commonProps = {
      formData,
      onChange,
    };

    switch (activeTab) {
      case "job_photos":
        return <JobPhotosTab {...commonProps} />;
      default:
        return <div>Tab not found</div>;
    }
  };

  return <div className="py-6">{renderTab()}</div>;
};

export default TabContent;
